const menu = [
  {
    label: "Administración de PQRs",
    icon: "",
    path: "/pqr",
  },
  {
    label: "Normatividad",
    icon: "",
    path: "/normatividad",
  },
  {
    label: "Usuarios",
    icon: "",
    path: "/usuarios",
  },
];

export default menu;